var convertQueryToObject=function(url){var arr=url.slice(1).split(/&|=/);var params={};for(var i=0;i<arr.length;i+=2)
{var key=arr[i],value=arr[i+1];params[key]=value}return params};module.exports=convertQueryToObject;